import YouTube from 'react-youtube';

import { Box } from '@chakra-ui/react';
import { headerHeight } from '@udacity/udacity-header-v2';

import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { trackEvent } from '~/features/analytics/track-event';

export type VideoSectionProps = {
  title: string;
  youtubeVideoId: string;
};

export function VideoSection({ title, youtubeVideoId }: VideoSectionProps) {
  return (
    <Box
      as='section'
      bgColor='white'
      id='trailer'
      isolation='isolate'
      scrollMarginTop={headerHeight}
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer textAlign='center'>
        <HeadingWithEmphasis
          text={title}
          emphasisProps={{
            background: 'linear-gradient(90.09deg, #62BBFF 25.17%, #006AFF 52.01%)',
            backgroundClip: 'text',
            textShadow: '0 0 24px rgba(98, 187, 255, 0.5)',
            sx: {
              backgroundClip: 'text',
              textFillColor: 'transparent',
            },
            fontWeight: '500',
          }}
          headingProps={{
            as: 'h1',
            fontWeight: '400 !important',
            mb: {
              base: 6,
              md: 10,
            },
            size: {
              base: 'marketing-2xl',
              md: 'marketing-5xl',
            },
            whiteSpace: 'pre-wrap',
            color: 'black',
          }}
        />

        <Box
          bgColor='white'
          borderRadius='10px'
          margin='0 auto'
          maxWidth='900px'
          position='relative'
          _hover={{
            '#play-icon': {
              transform: 'scale(1.1)',
            },
          }}
          sx={{
            '&::before': {
              content: '""',
              bgGradient: 'linear(107.67deg, #62BBFF 0%, #006AFF 99.16%)',
              borderRadius: '10px',
              borderWidth: '2px',
              inset: 0,
              position: 'absolute',
              zIndex: -1,
              margin: '-10px',
            },
          }}
        >
          <Box borderRadius='10px' height='100%' overflow='hidden' position='relative' width='100%'>
            <YouTube
              title={title}
              videoId={youtubeVideoId}
              opts={{
                host: 'https://www.youtube-nocookie.com',
                playerVars: {
                  rel: 0,
                },
                width: '100%',
                height: '100%',
              }}
              style={{
                aspectRatio: 16 / 9,
              }}
              onPlay={() =>
                trackEvent({
                  type: 'click',
                  name: 'Agentic AI Page CTA Clicked',
                  label: 'play_trailer',
                })
              }
            />
          </Box>
        </Box>
      </ContentContainer>
    </Box>
  );
}
